// Generated by genversion.
export const version = '2.3.0';
//# sourceMappingURL=version.js.map